import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Inicial from '../pages/Inicial';
import Principal from '../pages/Principal';
import Unica from '../pages/Unica';
import Recorrente from '../pages/Recorrente';
import Mirim from '../pages/Mirim';
import Paypal from '../pages/Paypal';
import ClubePaiEterno from '../pages/ClubePaiEterno';

const Routes: React.FC = () => (
  <Switch>
    <Route path="/" exact component={Inicial} />
    <Route path="/doacoes" exact component={Principal} />
    <Route path="/cadastro-mirim" exact component={Mirim} />
    <Route path="/doacao-recorrente" exact component={Recorrente} />
    <Route path="/doacao-unica" exact component={Unica} />
    <Route path="/clube-pai-eterno" exact component={ClubePaiEterno} />
    <Route path="/doacao-internacional" exact component={Paypal} />


  </Switch>
);

export default Routes;
